import { render, staticRenderFns } from "./create-username.vue?vue&type=template&id=96e16a2c&"
import script from "./create-username.vue?vue&type=script&lang=js&"
export * from "./create-username.vue?vue&type=script&lang=js&"
import style0 from "@/assets/auth-screen.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-username.vue"
export default component.exports